// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetStatusDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class AssetStatusApiClient extends BaseCRUDApiClient<AssetStatusDto> {
  baseUrl = this.config.apiEndpoint + '/asset-status';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
